// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    id: z.string().min(1).max(21),
    tenantId: z.string().max(21).optional(),
    ssoConnectorId: z.string().min(1).max(128),
    privateKey: z.string().min(1),
    certificate: z.string().min(1),
    createdAt: z.number().optional(),
    expiresAt: z.number(),
    active: z.boolean(),
});
const guard = z.object({
    id: z.string().min(1).max(21),
    tenantId: z.string().max(21),
    ssoConnectorId: z.string().min(1).max(128),
    privateKey: z.string().min(1),
    certificate: z.string().min(1),
    createdAt: z.number(),
    expiresAt: z.number(),
    active: z.boolean(),
});
export const SamlSsoConnectorSigningKeys = Object.freeze({
    table: 'saml_sso_connector_signing_keys',
    tableSingular: 'saml_sso_connector_signing_key',
    fields: {
        id: 'id',
        tenantId: 'tenant_id',
        ssoConnectorId: 'sso_connector_id',
        privateKey: 'private_key',
        certificate: 'certificate',
        createdAt: 'created_at',
        expiresAt: 'expires_at',
        active: 'active',
    },
    fieldKeys: [
        'id',
        'tenantId',
        'ssoConnectorId',
        'privateKey',
        'certificate',
        'createdAt',
        'expiresAt',
        'active',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
